<div class="menubar-hoverable header-fixed menubar-pin"
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">

  <!-- header -->
  <!--  -->
  <!-- BEGIN BASE-->
  <div id="base">
    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->
    <!-- BEGIN CONTENT-->
    <div id="content">
      <section class="has-actions style-default-bright">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="text-primary">{{ 'manageClass' | translate }}</h2>
          </div><!--end .col -->
          <div class="col-lg-6">
            <article class="margin-bottom-xxl">
              <p class="lead" style="color: #828282;">
                {{ 'manageYourClassCategoriesSectionsTimetables' | translate }}
              </p>
            </article>
          </div><!--end .col -->
          <!-- BEGIN LAYOUT LEFT ALIGNED -->
          <div class="col-md-12">
            <div class="">
              <div class="card-head">
                <!-- HEADER -->
                <div class="nav nav-tabs">
                  <div class="class-management" data-target="#tab-categories" data-toggle="tab"
                    *ngIf="permissions.ADD_CATEGORY == 'ENABLED' || permissions.VIEW_CATEGORY == 'ENABLED'"
                    [ngClass]="{'active': activeTab === 'categories'}" (click)="setActive('categories')">
                    <img src="../../assets/img/categories.svg" class="header-image"
                      [ngClass]="{'active': activeTab === 'categories'}">
                    <span class="tab-categories tab-text">
                      {{'categories' | translate}}
                    </span>
                  </div>
                  <div class="class-management" data-target="#tab-classes" data-toggle="tab"
                    *ngIf="permissions.ADD_CLASS_STANDARDS == 'ENABLED' || permissions.CLASS_STANDARD == 'ENABLED'"
                    [ngClass]="{'active': activeTab === 'classes'}" (click)="setActive('classes')">
                    <img src="../../assets/img/classStandards.svg" class="header-image"
                      [ngClass]="{'active': activeTab === 'classes'}">
                    <span class="tab-classes tab-text">
                      {{'classStandards' | translate}}
                    </span>
                  </div>
                  <div class="class-management" data-target="#tab-subjects" data-toggle="tab"
                    *ngIf="permissions.ADD_SUBJECT == 'ENABLED' || permissions.VIEW_SUBJECTS == 'ENABLED'"
                    [ngClass]="{'active': activeTab === 'subjects'}" (click)="setActive('subjects')">
                    <img src="../../assets/img/subjects.svg" class="header-image"
                      [ngClass]="{'active': activeTab === 'subjects'}">
                    <span class="tab-subjects tab-text">
                      {{'subjects' | translate}}
                    </span>
                  </div>
                  <div class="class-management" *ngIf="permissions.TIME_TABLE_MANAGEMENT == 'ENABLED'"
                    data-target="#tab-timetable" data-toggle="tab" [ngClass]="{'active': activeTab === 'timetable'}"
                    (click)="setActive('timetable'); editButtonHide()">
                    <img src="../../assets/img/timeTable.svg" class="header-image"
                      [ngClass]="{'active': activeTab === 'timetable'}">
                    <span class="tab-timetable tab-text">
                      {{'timeTable' | translate}}
                    </span>
                  </div>
                  <div class="class-management" [ngClass]="{'active': activeTab === 'attendance'}"
                    (click)="setActive('attendance')" data-target="#tab-attendance" data-toggle="tab"
                    (click)="handleAttendanceDetails()">
                    <img src="../../assets/img/attendance.svg" class="header-image"
                      [ngClass]="{'active': activeTab === 'attendance'}">
                    <span class="tab-attendance tab-text">
                      {{'attendance' | translate}}
                    </span>
                  </div>
                </div>
              </div><!--end .card-head -->
              <div class="card-body tab-content" style="padding: 0;">
                <!-- CATEGORIES -->
                <div class="tab-pane" [ngClass]="{'active': activeTab === 'categories'}" id="tab-categories">
                  <div class="particles-bg-main">
                    <div class="col-md-12" style="padding: 35px 20px 15px 20px;text-align: center;top: 0em;">
                      <h3 style="font-weight: 100;margin: 0;color: #777777;margin-bottom: 5px;">{{ 'listOfAllCategoriesInTheAcademicInstitution' | translate }}</h3>
                      <h4 [style.display]="permissions.ADD_CATEGORY == 'ENABLED' ? '':'none'"
                        style="color: #6b6b6b;font-weight: 300;margin-right: 10px;"> {{ 'wantToAddMoreCategoryInYourAcademicInstitution' | translate }} </h4>
                      <button [style.display]="permissions.ADD_CATEGORY == 'ENABLED' ? '':'none'" type="button"
                        class="btn btn-raised ink-reaction btn-info" data-toggle="modal"
                        data-target="#add-new-categories" (click)="clearAddCatData()" style="padding: 0px 75px;">{{ 'addNew' | translate }}</button>
                    </div>
                  </div>
                  <div class="col-md-12" [style.display]="getCategoryListArray.length > 0 ? '':'none'"
                    style="min-height: 400px;">
                    <table id="categoryview-detail-table" class="table table-striped class-details-table"
                      style="padding: 5px">
                      <thead>
                        <tr>
                          <th style="padding-left: 10px;">{{ 'categoryName' | translate }}</th>
                          <th style="padding-left: 10px;">{{ 'totalClasses' | translate }}</th>
                          <th style="padding-left: 10px;">{{ 'totalSections' | translate }}</th>
                          <th style="padding-left: 10px;">{{ 'studentsInThisCategory' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let category of getCategoryListArray"
                          (click)="classDetailView(catname.innerText,ttclasses.innerText,ttsections.innerText,ttstudents.innerText,category)"
                          style="cursor:pointer;">
                          <td #catname>{{category.CategoryName}}</td>
                          <td #ttclasses>{{category.TotalClasses}} {{ 'classes' | translate }}</td>
                          <td #ttsections>{{category.TotalSections}} {{ 'sections' | translate }}</td>
                          <td #ttstudents>{{category.TotalStudent}} {{ 'students' | translate }}</td>
                          <span #catid style="display:none"></span>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                  </div>
                  <div [style.display]="getCategoryListArray.length > 0 ? 'none':''" class="col-md-12 text-center">
                    <h4> {{ 'thereAreNoCategoriesAvailable' | translate }}</h4>
                  </div>
                </div>
                <!-- End CATEGORIES -->

                <!-- CLASSES -->
                <div class="tab-pane" id="tab-classes">
                  <div id="classList">
                    <div class="col-md-12" style="padding: 35px 20px 15px 20px; text-align: center;">
                      <h3 style="font-weight: 100;margin: 0;color: #777777;margin-bottom: 5px;">{{ 'listOfAllClassStandardsInTheAcademicInstitution' | translate }}</h3>
                      <h4 [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'"
                        style="color: #6b6b6b;font-weight: 300;margin-right: 10px;"> {{ 'wantToAddMoreClassStandardsInYourAcademicInstitution' | translate }} </h4>
                      <button [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'" type="button"
                        class="btn btn-raised ink-reaction btn-info" data-toggle="modal" data-target="#add-new-class"
                        style="padding: 0px 75px;" (click)="addNewClassModal()">{{ 'addNew' | translate }}</button>
                    </div>
                    <div [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'"
                      class="col-md-8 col-md-offset-2 text-center"
                      style="color: #6b6b6b;font-weight: 300;">
                      <h4>{{ 'wantToUpdateClassStandardOrder' | translate }} <span (click)="initiateOrderClassStandards()"
                          style="cursor: pointer"><u>{{ 'clickHere' | translate }}</u></span></h4>
                    </div>
                    <div class="col-md-12"
                      [style.display]="getClassListArray.length > 0 && !enableClassSequence ? '':'none'"
                      style="padding: 25px 30px;min-height: 400px;">
                      <table id="classview-detail-table" class="table table-striped class-details-table"
                        style="width: 100% !important;">
                        <thead>
                          <tr>
                            <th class="hide"></th>
                            <th style="padding-left: 10px;">{{ 'className' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'totalSections' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'classCategory' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'studentsInThisClass' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'staffsInThisClasss' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="offcanvas-viewClasses" style="cursor:pointer;"
                            *ngFor="let class of getClassListArray;let i=index"
                            (click)="getclassDetailView(className.innerText,totalSections.innerText,categoryName.innerText,classId.innerText,totalStudents.innerText,totalStaffs.innerText,catId.innerText,classStdId.innerText)">
                            <td class="hide">{{i}}</td>

                            <td #className>{{class.ClassName}}</td>
                            <td><span #totalSections>{{class.TotalSection}}</span> {{ 'sections' | translate }}</td>
                            <td #categoryName>{{class.categoryName}}</td>
                            <td><span #totalStudents>{{class.TotalStudent}}</span> {{ 'students' | translate }}</td>
                            <td #totalStaffs>{{class.TotalStaff}} {{ 'staffs' | translate }}</td>
                            <span #catId style="display:none">{{class.categoryId}}</span>
                            <span #classId style="display:none">{{class.classId}}</span>
                            <span #classStdId style="display:none">{{class.fkClassStandardsId}}</span>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div [style.display]="getClassListArray.length > 0 ? 'none':''" class="col-md-12 text-center">
                      <h4> {{ 'thereAreNoClassesAvailable' | translate }}</h4>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" id="classes-Status"
                    style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 15em;">
                    <img src="images_ext/default.gif">
                    <h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>{{ 'pleaseWait' | translate }}</h3>
                  </div>
                  <div id="updateClassSequenceOrder" *ngIf="enableClassSequence">
                    <div class="col-md-8 text-center">
                      <h3 style="color: var(--brand-primary-color);float: left;">{{ 'updateClassStandardOrder' | translate }}</h3>
                    </div>
                    <!-- <div class="col-md-4 text-right" style="padding-top: 15px;">
                      <button type="button" (click)="enableClassSequence = false" class="btn btn-raised ink-reaction btn-info cancelupdateorder">Cancel</button>
                      <button type="button" class="tttttttt btn btn-raised ink-reaction btn-info" (click)="updateClassOrder()">Save</button>
                    </div> -->
                    <div style="padding: 0px 15px">
                      <table class="table table-striped class-details-table">
                        <thead>
                          <tr>
                            <th style="padding-left: 10px;">{{ 'sort' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'className' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'totalSections' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'classCategory' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'studentsInThisCategory' | translate }}</th>
                            <th style="padding-left: 10px;">{{ 'staffsInThisCategory' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody class="list">
                          <tr *ngFor="let std of getClassListArray; let i=index">
                            <td><input style="width: 30px; height: 30px;text-align: center;" type="text"
                                [(ngModel)]="std.Sequence" (keyup)="validateClassOrder(std, i)" /></td>
                            <td #className>{{std.ClassName}}</td>
                            <td><span #totalSections>{{std.TotalSection}}</span> {{ 'sections' | translate }}</td>
                            <td #categoryName>{{std.categoryName}}</td>
                            <td><span #totalStudents>{{std.TotalStudent}}</span> {{ 'students' | translate }}</td>
                            <td #totalStaffs>{{std.TotalStaff}} {{ 'staffs' | translate }}</td>
                            <span #sequence style="display:none">{{std.Sequence}}</span>
                            <span class="classId" #classId style="display:none">{{std.classId}}</span>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 text-right" style="padding: 15px 15px;">
                      <button type="button" (click)="enableClassSequence = false"
                        class="btn btn-raised ink-reaction btn-info cancelupdateorder">{{ 'cancel' | translate }}</button>
                      <button type="button" class="tttttttt btn btn-raised ink-reaction btn-info"
                        (click)="updateClassOrder()">{{ 'save' | translate }}</button>
                    </div>
                  </div>
                </div>
                <!-- End CLASSES -->

                <!-- SUBJETS -->
                <div class="tab-pane" id="tab-subjects">
                  <div class="col-md-12" style="padding: 35px 20px 15px 20px; text-align: center;">
                    <h3 style="font-weight: 100;margin: 0;color: #777777;margin-bottom: 5px;">{{ 'listOfAllSubjectsInTheAcademic' | translate }}</h3>
                    <div [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'" id="addSubjectNew">
                      <h4 style="color: #6b6b6b;font-weight: 300;margin-right: 10px;"> {{ 'wantToAddMoreSubjectsInYourAcademic' | translate }} </h4>
                      <button id="addSubjectButton" type="button" (click)="clearAddSubData()"
                        class="btn btn-raised ink-reaction btn-info" style="padding: 0px 75px;">{{ 'addNew' | translate }}</button>
                    </div>
                  </div>
                  <div id="add-new-subject" class="col-md-6 col-md-offset-3" style="display: none">
                    <div class="form-group">
                      <div class="input-group">
                        <div class="input-group-content text-left">
                          <input type="text" class="form-control" id="groupbutton91" [(ngModel)]="addSub.subjectname"
                            name="addSubject">
                          <label for="groupbutton9" style="margin-top: -10px;">{{ 'subjectName' | translate }}</label>
                        </div>
                        <div class="input-group-btn">
                          <button id="addSubButton" class="btn btn-raised ink-reaction btn-info" type="button"
                            (click)="addNewSubject(addSub)">{{ 'addSubject' | translate }}</button>
                          <button id="canceladdnewSubject" class="btn btn-raised ink-reaction btn-info" type="button"
                            style="margin-left: 5px;">{{ 'cancel' | translate }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" [style.display]="getSubjectListArray.length > 0 ? '':'none'"
                    style="padding: 25px 30px;min-height: 400px;">
                    <table id="subject-List-table" class="table table-striped class-details-table">
                      <thead>
                        <tr>
                          <th style="padding-left: 10px;">{{ 'subjectName' | translate }}</th>
                          <th style="padding-left: 10px;">{{ 'subjectBelongingClasses' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="cursor:pointer;" *ngFor="let subjects of getSubjectListArray"
                          (click)="getsubjectDetailView(subjectName.innerText,subjectId.innerText,subjectBelonging.innerText)">
                          <td #subjectName>{{subjects.subject}}</td>
                          <td #subjectBelonging>{{subjects.belongingClasses}} {{ 'classes' | translate }}</td>
                          <span #subjectId style="display:none">{{subjects.subjectId}}</span>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div [style.display]="getSubjectListArray.length > 0 ? 'none':''" class="col-md-12 text-center">
                    <h4> {{ 'thereAreNoSubjectAvailable' | translate }}</h4>
                  </div>
                </div>
                <!-- End SUBJETS -->

                <!-- TIMETABLE -->
                <div class="tab-pane" id="tab-timetable">
                  <div class="card-body">
                    <div id="timetableslots">
                      <form class="form-inline text-center search-groups" autocomplete="off">
                        <div class="form-group zed-index-1" style="z-index: 10;">
                          <label for="select13" class="control-label">{{ 'class' | translate }}</label>
                          <select id="select15" name="select13" class="form-control"
                            (change)="getSectionListClassView($event.target.value)">
                            <option value="0">{{ 'selectClass' | translate }}</option>
                            <option *ngFor="let class of getClassListArray" value="{{class.fkClassStandardsId}}">
                              {{class.ClassName}}</option>
                          </select>
                          <div class="form-control-line"></div>
                        </div>
                        <div class="form-group zed-index-1" style="z-index: 10;">
                          <label for="select13" class="control-label">{{ 'section' | translate }}</label>
                          <select id="sectionOfClass" name="select13" class="form-control">
                            <option value="0">{{ 'selectSection' | translate }}</option>
                            <option *ngFor="let section of getClassViewClassSectionArray"
                              value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}
                            </option>
                          </select>
                          <div class="form-control-line"></div>
                        </div>
                        <button style="z-index: 10;" type="button" id="select-class-time"
                          class="btn btn-raised ink-reaction btn-info zed-index-1"
                          (click)="ViewClassTimetable();getTimetable(classStdSectionId)">{{ 'view' | translate }}</button>
                        <button style="z-index: 10;" type="button" id="addTimeTable"
                          class="btn btn-raised ink-reaction btn-info zed-index-1"
                          (click)="getClassCategories()">{{ 'configure' | translate }}</button>
                        <div class="col-md-12 text-right" style="margin-top: -60px;margin-left: -37px;z-index: 0">
                          <input (click)="editTimeTable()" type="button" [attr.value]="'edit' | translate"  id="edit-timetable"
                            style="float:right" class="btn btn-raised ink-reaction btn-info" />
                          <input (click)="cancelEditButton()" type="button" [attr.value]="'cancel' | translate" id="cancel-edit-timetable"
                            style="float:right;margin-right: -9px;"
                            class="btn btn-raised ink-reaction btn-info edit-time-table hide " />
                          <input (click)="saveTimeTable()" type="button" id="savettforupadte"
                            style="display: inline-block;margin-right: -161px;margin-left: 10px;" [attr.value]="'save' | translate"
                            class="btn btn-raised ink-reaction btn-info" />
                        </div>
                      </form>
                      <div class="col-md-12 text-right" style="padding: 10px 12px;">
                        <span class="tag label label-info" id="msghide" style="float: left;margin-top: 17px;">{{ 'pleasePressEscapeButtonToClearCopy' | translate }}</span>
                      </div>
                      <div class="time-table-information col-md-12">
                        <!--<h3 class="class-teacher-info">Time Table</h3>-->
                        <div class="table-responsive time-table-inner-container-info">
                          <!--<select id="select-class-time" class="select-class-info-details">
                            <option>Select Class</option>
                          </select>-->






                          <!--input(type="button",value='Print',class='btn btn-raised btn-primary' id='print-timetable' style='float:right')-->

                          <table id="timetable" class="table table-bordered text-center timetable-view">
                            <thead class="header-in-table" style="background: #dadada;">
                              <tr>
                                <th class="class-teacher-info text-center">{{ 'periodDay' | translate }}</th>
                                <th id="timetablethday1" class="class-teacher-info text-center">{{ 'monday' | translate }}</th>
                                <th id="timetablethday2" class="class-teacher-info text-center">{{ 'tuesday' | translate }}</th>
                                <th id="timetablethday3" class="class-teacher-info text-center">{{ 'wednesday' | translate }}</th>
                                <th id="timetablethday4" class="class-teacher-info text-center">{{ 'thursday' | translate }}</th>
                                <th id="timetablethday5" class="class-teacher-info text-center">{{ 'friday' | translate }}</th>
                                <th id="timetablethday6" class="class-teacher-info text-center">{{ 'saturday' | translate }}</th>
                                <th id="timetablethday7" class="class-teacher-info text-center">{{ 'sunday' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="active">
                                <td colspan="8">{{ 'selectClassToViewTimetable' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div name="timetable" class="update-time-table-container-info"
                            style="padding: 2em 0em;float: right;">
                            <button (click)="saveTimeTable()" type="button" value="Save" id="saveTimetable"
                              class="btn btn-raised ink-reaction btn-info update-timetable-btn">{{ 'save' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="configureTimeTable" class="card col-md-8 col-md-offset-2" style="display: none">
                      <div class="time-table-inner-container" style="padding: 1em 2em;">
                        <i class="fa fa-clock-o fa-2x" aria-hidden="true" style="color: var(--brand-primary-color);"></i>
                        <h3 class="class-teacher-info" style="margin-top: -1.4em;margin-left: 1.5em;color: var(--brand-primary-color);">
                          {{ 'configureTimeTable' | translate }}</h3>
                        <div class="time-table-big-container">
                          <div class="time-table-container col-md-12" style="padding: 1em 0em;">
                            <form class="form-inline text-center search-groups" autocomplete="off">
                              <div class="form-group">
                                <label for="select13" class="control-label">{{ 'category' | translate }}</label>
                                <select class="category-selector form-control" id="category-info-time-table"
                                  name="categoryList" style="border: 1px solid gainsboro;color: gray;">
                                  <option value="0">{{ 'selectCategory' | translate }}</option>
                                  <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                                    {{category.categoryName}}</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label class="text-left" style="margin-top: -7px;">{{ 'numberOfPeriods(includingBreaks' | translate }}</label>
                                <input type="text" required="" class="form-control" id="time-period" name="peroid"
                                  maxlength="2" style="border: 1px solid gainsboro;padding: 0 0 0 12px;"><span
                                  class="highlight"></span><span class="bar"></span>
                              </div>
                            </form>
                          </div>
                          <div class="time-table-container col-md-12" style="padding-top: 2em">
                            <div class="select-days col-md-4">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="monday" day="monday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'monday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="tuesday" day="tuesday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'tuesday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="wednesday" day="wednesday"
                                  name="days"><span class="checkbox-material"><span
                                    class="check"></span></span>{{ 'wednesday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4" style="margin-top: 10px">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="thursday" day="thursday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'thursday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4" style="margin-top: 10px">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="friday" day="friday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'friday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4" style="margin-top: 10px">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="saturday" day="saturday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'saturday' | translate }}
                              </label>
                            </div>
                            <div class="select-days col-md-4" style="margin-top: 10px">
                              <label class="checkbox-inline checkbox-styled checkbox-primary">
                                <input class="configDay" type="checkbox" id="sunday" day="sunday" name="days"><span
                                  class="checkbox-material"><span class="check"></span></span>{{ 'sunday' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="time-table-container-for-period-timeand-lunch-time col-md-12"
                            style="padding-top: 2em">
                            <form class="form col-md-12">
                              <div class="form-group col-md-4" style="margin-left: -10px;">
                                <input class="form-control" type="text" required="" id="class-duration"
                                  name="classDuration"><span class="highlight"></span><span class="bar"></span>
                                <label style="margin-left: 15px;">{{ 'classDuration(minutes' | translate }}</label>
                              </div>
                              <div class="form-group col-md-4">
                                <input class="form-control" type="text" required="" id="break-duration"
                                  name="breakDuration"><span class="highlight"></span><span class="bar"></span>
                                <label style="margin-left: 15px;">{{ 'breakDuration(minutes' | translate }}</label>
                              </div>
                              <div class="form-group col-md-4">
                                <input class="form-control" type="text" required="" id="lunch-duration"
                                  name="lunchDuration"><span class="highlight"></span><span class="bar"></span>
                                <label style="margin-left: 15px;">{{ 'lunchBreak(minutes' | translate }}</label>
                              </div>
                            </form>
                          </div>
                          <div class="time-table-container col-md-12" id="timeOfperied">
                            <!--<form class="form">

                                      <div class="form-group col-md-3">
                                        <input type="text" id="starttime" placeholder="Start Time" [(ngModel)]="p.startTime" (change)="startTimeii($event.target.value)" class="form-control plug-time starttime" [ngClass]="custom-cls" name="startTime" style="border: 1px solid gainsboro;font-size: small;">
                                      </div>
                                      <div class="col-md-1" style="margin-top: 1.5em;color: gray;">
                                        <h5>TO</h5>
                                      </div>
                                      <div class="form-group col-md-3">
                                        <input type="text" class="form-control plug-time endtime" id="regular2" (change)="endTime($event.target.value)" placeholder="End Time" [(ngModel)]="p.endTime" name="endTime" style="border: 1px solid gainsboro;font-size: small;">
                                      </div>
                                      <div class="form-group col-md-4">
                                        <select class="form-control" id="periodType" [(ngModel)]="p.type" name="type" style="border: 1px solid gainsboro;font-size: small;color: gray;">
                                          <option value="1">Class</option>
                                          <option value="0">Break</option>
                                          <option value="2">Lunch</option>
                                        </select>
                                      </div>
                                    </form>-->
                          </div>
                          <div class="update-time-table-container col-md-12 text-right" style="padding: 2em 2em;">
                            <button type="button" id="cancelTimeTable"
                              class="btn btn-raised ink-reaction btn-info">{{ 'cancel' | translate }}</button>
                            <button type="button" class="btn btn-raised ink-reaction btn-info" action="create"
                              id="saveTimetableConfig">{{ 'save' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End TIMETABLE -->

                <!-- ATTENDANCE -->

                <div class="tab-pane attendance-card" id="tab-attendance">
                  <div class="attendance-container" *ngIf="!loader && classAttendanceDetails.length > 0">
                    <div class="search-container" [class.active]="isSearchActive || searchValue">
                      <div class="search-image">
                        <img src="../../assets/img/search.svg" alt="search-icon" />
                      </div>
                      <input type="text" class="search-box" [placeholder]="'search' | translate" [(ngModel)]="searchValue"
                        (blur)="handelOnBlurSearch()" (input)="filterClassDetailsData()" maxlength="50" />
                    </div>
                    <div class="attendance-config">
                      <span class="config-label">{{'attendanceConfiguration' | translate}}</span>
                      <div class="config-toggle">
                        <button type="button" class="toggle-option"
                          [ngClass]="{'global-attendance-Active':(globalAttendanceConfigurationStatusData === 'DAY' || globalAttendanceConfigurationStatusData === 'MIXED')}"
                          id="day" (click)="handleGlobalAttendanceConfig('DAY')">
                          {{'day' | translate}}
                        </button>
                        <button type="button" class="toggle-option"
                          [ngClass]="{'global-attendance-Active':globalAttendanceConfigurationStatusData === 'PERIOD'}"
                          id="period" (click)="handleGlobalAttendanceConfig('PERIOD')">
                          {{'period' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mixed-type-text"
                    *ngIf="!loader && classAttendanceDetails.length > 0 &&  globalAttendanceConfigurationStatusData ==='MIXED' ">
                    {{'mixedAttendanceConfigurationMessage' | translate}}
                  </div>
                  <div class="attendance-body-card" *ngIf="!loader && filterClassDetails.length > 0 ">
                    <div class="attendance-sub-card" *ngFor="let attendanceDetails of filterClassDetails">
                      <div class="attendance-details">
                        <div class="attendance-class-name" [attr.title]="attendanceDetails.classNumber.length > 15 ? attendanceDetails.classNumber : ''">{{attendanceDetails.classNumber.length > 15 ? attendanceDetails.classNumber.slice(0, 15) + "..." : attendanceDetails.classNumber}} -
                          {{attendanceDetails.classDivision}}</div>
                        <div class="attendance-inside-toggle">
                          <button class="toggle-btn"
                            [ngClass]="{'class-wise-attendance-active':attendanceDetails.attendanceType === 'DAY'}"
                            (click)="handleClassWiseAttendanceConfig(attendanceDetails, 'DAY')"
                            [disabled]="attendanceDetails.dayLoader">
                            <ng-container *ngIf="attendanceDetails.dayLoader; else notLoadingDay">
                              <app-button-loader></app-button-loader>
                            </ng-container>
                            <ng-template #notLoadingDay>
                              {{'day' | translate}}
                            </ng-template>
                          </button>
                          <button class="toggle-btn"
                            [ngClass]="{'class-wise-attendance-active':attendanceDetails.attendanceType === 'PERIOD'}"
                            (click)="handleClassWiseAttendanceConfig(attendanceDetails, 'PERIOD')"
                            [disabled]="attendanceDetails.periodLoader">
                            <ng-container *ngIf="attendanceDetails.periodLoader; else notLoadingPeriod">
                              <app-button-loader></app-button-loader>
                            </ng-container>
                            <ng-template #notLoadingPeriod>
                              {{'period' | translate}}
                            </ng-template>
                          </button>
                        </div>
                      </div>
                      <div class="class-teacher-details">
                        <img src="../../assets/img/teaching.svg" alt="teacher-icon" class="teacher-image"
                          title="Class teacher name" />
                        <span class="teacher-name">{{attendanceDetails.classTeacherName ?
                          attendanceDetails.classTeacherName : ('NA' | translate)}}</span>
                      </div>
                      <div class="class-timetable-details" *ngIf="attendanceDetails.isTimeTableConfigured !== 1">
                        <img src="../../assets/img/alert-circle.svg" alt="alert-icon" class="teacher-image" />
                        <span class="timetable-configuration">{{ attendanceDetails.isTimeTableConfigured !== 1 ?
                          ('timetableNotConfigured'|translate ): '' }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!loader && classAttendanceDetails.length === 0" class="class-not-exist-container">
                    <img src="../../assets/img/details-not-exist.svg" alt="details-not-exist"
                      class="details-not-exist-image" />
                    <p class="details-not-exist-message">{{'classNotAvailableMessage' | translate}}</p>
                  </div>

                  <div class="search-details-not-exist" *ngIf="!loader && filterClassDetails.length === 0 ">
                    {{'classNotExist'| translate}}
                  </div>
                  <app-new-loader *ngIf="loader"></app-new-loader>
                </div>
                <!-- END ATTENDANCE -->

              </div><!--end .card-body -->
            </div><!--end .card -->
          </div><!--end .col -->
          <!-- END LAYOUT LEFT ALIGNED -->
        </div>

        <!-- Order class standards and sections -->
        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="order-class-standards"
          aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ 'orderClassesSections' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body col-md-12">
                <div class="row col-md-12" style="display: flex;">
                  <div class="col-md-6" style="border: 1px solid #dddddd;    background: #cbcbcb;">
                    <div class="row" style="padding: 5px;text-align: center;font-weight: bold;">{{ 'sortClasses' | translate }}</div>
                    <div class="row">
                      <ul style="padding: 5px;text-align: center;" cdkDropList
                        (cdkDropListDropped)="classDropped($event)" class="list-group cursor-grab">
                        <li (mousedown)="dropListItemMoveStart(class, i)"
                          *ngFor="let class of classesListToDrag; let i=index" cdkDrag class="list-group-item"
                          [ngClass]="{
                          'drag-items': class.isDragging
                        }">
                          <span style="float: left; margin-top: 3px;" class="badge badge-primary">{{i+1}}</span>
                          <span style="text-transform: uppercase;">{{class.ClassName}}</span>
                          <span (click)="initiateSectionDrag(class)" class="btn btn-primary"
                            style="float: right; margin-top: -6px;font-size: unset; text-transform: unset;">
                            <i style="float: right; margin-top: 6px;margin-left: 2px;" class="fa fa-chevron-right"
                              aria-hidden="true"></i>
                            {{ 'orderSections' | translate }}
                          </span>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-primary active" style="float: right;
                      text-transform: unset;
                      margin-right: 5px;margin-bottom: 5px;" (click)="saveClassesOrder(classesListToDrag)">{{ 'saveClassesOrder' | translate }}</button>
                    </div>
                  </div>

                  <div class="col-md-6" style="border: 1px solid #dddddd;margin-left: 5px;    background: #cbcbcb;">
                    <div class="row" style="padding: 5px;text-align: center;font-weight: bold;" id="sortSectionsHead">
                      {{ 'sortSections' | translate }}</div>
                    <div class="row" *ngIf="sectionsListToDrag.length === 0"
                      style="text-align: center;margin-top: 10%;">
                      {{ 'clickOnAny' | translate }} <span class="btn btn-primary"
                        style="font-size: unset; text-transform: unset;pointer-events: none;">
                        <i style="float: right; margin-top: 6px;margin-left: 2px;" class="fa fa-chevron-right"
                          aria-hidden="true"></i>
                        {{ 'orderSections' | translate }}
                      </span> {{ 'toSortSectionsInAClass' | translate }}
                    </div>
                    <div class="row" *ngIf="sectionsListToDrag.length > 0">
                      <ul style="padding: 5px;text-align: center;" cdkDropList
                        (cdkDropListDropped)="classSectionsDropped($event)" class="list-group cursor-grab">
                        <li (mousedown)="dropSectionListItemMoveStart(class,i)"
                          *ngFor="let class of sectionsListToDrag; let i = index" cdkDrag class="list-group-item"
                          [ngClass]="{
                          'drag-items': class.isDragging
                        }">
                          <span style="float: left; margin-top: 3px;" class="badge badge-primary">{{i+1}}</span>
                          <span style="text-transform: uppercase;">{{class.className}} - {{class.classSection}}</span>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-primary active" style="float: right;
                      text-transform: unset;
                      margin-right: 5px;" (click)="saveSectionsOrder(sectionsListToDrag)">{{ 'saveSectionsOrder' | translate }}</button>
                    </div>

                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-primary" (click)="saveClassesOrder(classesListToDrag)">Save changes</button> -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'done' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Order class standards and sections End-->

        <!-- Add class modal -->
        <div class="modal fade" id="add-new-class" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="row col-md-12">
                <div class="col-md-6 text-center"
                  style="background-color: var(--brand-primary-color); color: white;    padding: 7.13em 0em;">
                  <i class="fa fa-building fa-4x" aria-hidden="true"></i>
                  <h3 class="lead">{{ 'addStandard' | translate }}</h3>
                  <hr style="border-top-color:#88c6f7;width:50%;margin-top:0;margin-bottom:0;">
                </div>
                <div class="col-md-6" style="background-color: white;padding: 15px 0px;height: 24.12em;">
                  <button
                    style="background-color: var(--brand-primary-color);margin-right: -1em;margin-top: -2em;float: right;border: none;"
                    type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                    aria-hidden="true">&times;</button>
                  <form class="form" role="form" style="padding: 0em 1em">
                    <div class="form-group">
                      <input type="text" class="form-control" id="class-name" [(ngModel)]="newStandardName"
                        [ngModelOptions]="{standalone: true}">
                      <label for="class-name" style="font-size:small;">{{ 'standardName' | translate }}</label>
                    </div>
                    <div class="form-group">
                      <select id="select111" name="class lead" class="form-control test1" style="font-size: smaller;"
                        (change)="selectcategoryAddSection($event.target.value)" [(ngModel)]="selectedCatIdAddSection">
                        <option value="0">{{ 'selectCategory' | translate }}</option>
                        <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                          {{category.categoryName}}</option>
                      </select>
                      <label for="select111" style="font-size: small;">{{ 'category' | translate }}</label>
                    </div>
                    <div class="form-group">
                      <input #newStandardSections type="text" id="addNewSection" class="form-control" value=""
                        data-role="tagsinput">
                      <label for="class-name" style="font-size:small;">{{ 'section' | translate }}</label>
                    </div>
                    <div class="text-center" style="padding-top: 1.5em">
                      <button type="button" id="stdName" class="btn btn-raised ink-reaction btn-info btn-md"
                        style="padding: 3px 20px;" (click)="addNewSection2(newStandardSections.value)">{{ 'add' | translate }}</button>
                      <button type="button" id="addstandards" data-dismiss="modal"
                        class="btn btn-raised ink-reaction btn-info btn-md" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Add timetable -->
        <div class="modal fade" id="add-new-timetable" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" style="min-height: 25em;">
              <div class="col-md-12">
                <div class="col-md-6 text-center"
                  style="background-color: var(--brand-primary-color);color: white;margin-left: -12px;padding: 8.1em 0em;">
                  <i class="fa fa-clock-o fa-4x" aria-hidden="true"></i>
                  <h3>{{ 'addTimetable' | translate }}</h3>
                  <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                </div>
                <div class="col-md-6" style="padding: 25px 0px;">
                  <button
                    style="background-color: var(--brand-primary-color);margin-right: -2.8em;margin-top: -2.8em;float: right;border: none;"
                    type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                    aria-hidden="true">&times;</button>
                  <div class="col-md-8 col-md-offset-1 form-group">
                    <label>{{ 'slotTime' | translate }}</label>
                    <p style="color: #a4b3c5;">{{ 'startTime' | translate }}</p>
                    <input type="text" class="form-control times" name="StartTime"
                      style="margin-top: -50px;margin-left: 75px;font-size: small;color: #a4b3c5;">
                    <p style="margin-top: 25px;color: #a4b3c5;">{{ 'endTime' | translate }}</p>
                    <input type="text" class="form-control times" name="EndTime"
                      style="margin-top: -48px;margin-left: 75px;font-size: small;color: #a4b3c5;">
                  </div>
                  <div class="col-md-10 col-md-offset-1" style="padding: 0px 7px;margin-top: -10px">
                    <form class="form">
                      <div class="form-group">
                        <input type="text" value="Monday,Tuesday,Wednesday,Thursday,Friday" data-role="tagsinput">
                        <label>{{ 'days' | translate }}</label>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-8 col-md-offset-1 form-group">
                    <label>{{ 'subjectName' | translate }}</label>
                    <input type="text" class="form-control" name="addclass" style="margin-top: -2em;margin-left: 5em;">
                  </div>
                  <div class="text-center">
                    <button type="button" class="btn btn-raised ink-reaction btn-info"
                      style="    margin-left: 15px;padding: 3px 20px;">{{ 'add' | translate }}</button>
                    <button type="button" class="btn btn-raised ink-reaction btn-info"
                      style="    margin-left: 15px;padding: 3px 20px;">{{ 'cancel' | translate }}</button>
                  </div>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Add categories -->
        <div class="modal fade" id="add-new-categories" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="margin-top: 8em;">
            <div class="modal-content">
              <div class="col-md-6 text-center" style="background-color: var(--brand-primary-color);color: white;padding: 2.85em 0em;">
                <i class="fa fa-th-large fa-4x" aria-hidden="true"></i>
                <h3>{{ 'addCategory' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white">
                <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form" style="padding: 2em 1em;">
                  <div class="form-group">
                    <input type="text" class="form-control" id="addNewCategoryCategoryName"
                      [(ngModel)]="addNewCategoryCategoryName" [ngModelOptions]="{standalone: true}">
                    <label for="addNewCategoryCategoryName" style="font-size: small;">{{ 'categoryName' | translate }}</label>
                  </div>
                </form>
                <div class="text-center" style="padding: 13px 0px;">
                  <button id="addNewCat" type="button" class="btn btn-raised ink-reaction btn-info btn-md"
                    (click)="addNewCategoryCategoryList()">{{ 'add' | translate }}</button>
                  <button type="button" id="addcategory" class="btn btn-raised ink-reaction btn-info btn-md"
                    data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Edit timetable -->
        <div class="modal fade" id="update-timetable" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="width: 75%;">
            <div class="modal-content">
              <div class="modal-header" style="border: none;">
                <button style="border: 1px solid #000000;padding: 1px 5px;outline: none;border-radius: 50%;"
                  type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              </div>
              <div class="modal-body" style="min-height: 12em;">
                <h5>{{ 'editTimetable' | translate }}</h5>
              </div>
              <div class="modal-footer">
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!--  -->

        <!-- Edit new subject -->
        <div class="modal fade" id="updateSubject" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="margin-top: 10em;">
            <div class="modal-content">
              <div class="col-md-6 text-center" style="background-color: var(--brand-primary-color);color: white;padding: 1.74em 0em;">
                <i class="fa fa-book fa-4x" aria-hidden="true"></i>
                <h3>{{ 'updateSubject' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white;">
                <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form" style="padding: 2em 1em;">
                  <div class="form-group">
                    <input type="text" class="form-control" id="subject" [(ngModel)]="getViewsubjectName"
                      [ngModelOptions]="{standalone: true}" value="{{getSubjectId}}">
                    <label for="subject" style="font-size: small;">{{ 'subjectName' | translate }}</label>
                  </div>
                  <div class="col-md-12 text-center" style="padding: 13px 0px;">
                    <button type="button" id="updateSub" class="btn btn-raised ink-reaction btn-info btn-md"
                      (click)="updateSubjectName()" style="padding: 3px 20px;">{{ 'update' | translate }}</button>
                    <button id="closeUpdateSubject" type="button" class="btn btn-raised ink-reaction btn-info btn-md"
                      data-dismiss="modal" aria-hidden="true" style="padding: 3px 20px;">{{ 'cancel' | translate }}</button>
                  </div>
                </form>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <!-- Edit Subject -->
      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->
    <!-- Start of OffCanvas -->
    <div class="offcanvas">
      <!-- View categories -->
      <div id="offcanvas-view-class-categories" class="offcanvas-pane width-12"
        style="width:1000px;    overflow-x: hidden;">
        <div class="modal fade" id="edit-selected-category-name" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" style="margin-top: 8em;">
            <div class="modal-content">
              <div class="col-md-6 text-center" style="background-color: var(--brand-primary-color);color: white;    padding: 2.85em 0em;">
                <i class="fa fa-th-large fa-4x" aria-hidden="true"></i>
                <h3>{{ 'editCategoryName' | translate }}</h3>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
              </div>
              <div class="col-md-6" style="background-color: white">
                <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                  type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                  aria-hidden="true">&times;</button>
                <form class="form" role="form" style="padding: 2em 1em;">
                  <div class="form-group">
                    <input type="text" class="form-control" id="editCategoryCategoryName"
                      [(ngModel)]="editCategoryCategoryName" [ngModelOptions]="{standalone: true}"
                      value="{{getViewCatName}}">
                    <label for="editCategoryCategoryName" style="font-size: small;">{{ 'categoryName' | translate }}</label>
                  </div>
                </form>
                <div class="text-center" style="padding: 13px 0px;">
                  <button id="upCatName" type="button" class="btn btn-raised ink-reaction btn-info btn-md"
                    (click)="updateCategoryCategoryName()">{{ 'update' | translate }}</button>
                  <button id="closeUpdateCatPopup" type="button" class="btn btn-raised ink-reaction btn-info btn-md"
                    data-dismiss="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-bg row" style="background: var(--secondary-btn-bg-color);min-height: 260px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center" style="position: absolute;top: 1em;">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'categoryDetails' | translate }}</p>
                <img src="assets/img/class-category.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'viewSelectedCategoryDetailsHere' | translate }}</p>
                <div class="row">
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'categoryName' | translate }}</span><br>{{getViewCatName}}
                  </p>
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'totalClasses' | translate }}</span><br>{{getViewttclasses}}
                  </p>
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'totalStudents' | translate }}</span><br>{{getViewttstudents}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'selectedCategoryDetails' | translate }}</h4>
              <div [style.display]="permissions.ADD_CATEGORY == 'ENABLED' ? '':'none'"
                style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button data-toggle="modal" data-target="#edit-selected-category-name" type="button"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;z-index: 999;"><i
                    class="fa fa-pencil-square-o"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="dataCategory" class="col-md-12 text-center" style="display: none">
                <h3>{{ 'thereAreNoClassesInThisCategory' | translate }}</h3>
              </div>
              <div id="tablebycategorylist" class="col-md-12 card" style="margin:0;padding: 20px 10px;">
                <table id="category-detail-view-table" class="table table-striped class-details-table">
                  <thead>
                    <tr>
                      <th>{{ 'className' | translate }}</th>
                      <th>{{ 'numberOfSections' | translate }}</th>
                      <th>{{ 'totalStudents' | translate }}</th>
                      <th>{{ 'view' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let categoryclass of classlistbycat"
                      (click)="categoryClassDetailView(categoryclass.ClassName,categoryclass.TotalSection,categoryclass.TotalStudent,categoryclass.classId)">
                      <td #className>{{categoryclass.ClassName}}</td>
                      <td #totalSections>{{categoryclass.TotalSection}} {{ 'sections' | translate }}</td>
                      <td #totalStudents>{{categoryclass.TotalStudent}}</td>
                      <td style="text-align: center;">
                        <button (click)="offcanvasviewclass(categoryclass,classId.innerText)" class="offcanvasviewclass"
                          style="padding: 3px 15px;background: #8c8c8c;border: none;border-radius: 10px;font-size: 10px;color: white;outline: none;text-decoration: none;">{{ 'viewClass' | translate }}</button>
                        <span #classId style="display:none">{{categoryclass.classId}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- End Student details -->
        </div>
      </div>
      <!-- End view categories -->

      <!--Update class name-->
      <div class="modal fade" id="edit-selected-category-class" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" style="margin-top: 8em;">
          <div class="modal-content">
            <div class="col-md-6 text-center" style="background-color: var(--brand-primary-color);color: white;padding: 2.85em 0em;">
              <i class="fa fa-th-large fa-4x" aria-hidden="true"></i>
              <h3>{{ 'editClassName' | translate }}</h3>
              <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
            </div>
            <div class="col-md-6" style="background-color: white">
              <button style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                aria-hidden="true">&times;</button>
              <form class="form" role="form" style="padding: 2em 1em;">
                <div class="form-group">
                  <input type="text" class="form-control stdName" id="editCategoryCategoryClassName"
                    [(ngModel)]="editCategoryCategoryClassName" name="className" [ngModelOptions]="{standalone: true}"
                    value="{{classStandardName}}">
                  <label for="editCategoryCategoryName" style="font-size: small;">{{ 'className' | translate }}</label>
                </div>
              </form>
              <div class="col-md-12 text-center" style="padding: 13px 0px;">
                <button type="button" id="classButton" class="btn btn-raised ink-reaction btn-info btn-md"
                  (click)="updateClassName(updateClassStdName)">{{ 'update' | translate }}</button>
                <button id="closeUpdateClass" type="button" class="btn btn-raised ink-reaction btn-info btn-md"
                  data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->

      <!--End of update class-->
      <!-- View class canvas -->
      <div id="offcanvas-view-class" class="offcanvas-pane width-12" style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-bg row" style="background: var(--secondary-btn-bg-color);min-height: 260px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center" style="position: absolute;top: 1em;">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'classDetails' | translate }}</p>
                <img src="assets/img/class-detail.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'viewSelectedClassDetailsHere' | translate }}</p>
                <div class="row">
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'className' | translate }}</span><br>{{classStandardName}}
                  </p>
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'category' | translate }}</span><br>{{getViewCatName}}
                  </p>
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'totalSections' | translate }}</span><br>{{getCategoryClassListtotalSections}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'selectedClassDetails' | translate }}</h4>
              <div [style.display]="permissions.ADD_CLASS_STANDARDS == 'ENABLED' ? '':'none'"
                style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button data-toggle="modal" data-target="#edit-selected-category-class" type="button"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;z-index: 999;"><i
                    class="fa fa-pencil-square-o"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card" style="margin-bottom: 0; padding-bottom: 3em;">
                <div class="card-head">
                  <ul class="nav nav-tabs" data-toggle="tabs" style="padding: 0;cursor: pointer">
                    <li class="active"><a data-target="#students-tab" data-toggle="tab">{{ 'students' | translate }}</a></li>
                    <li *ngIf="(permissions.ADD_CLASSES == 'ENABLED' || permissions.VIEW_CLASS_SECTIONS == 'ENABLED')">
                      <a data-target="#sections-tab" data-toggle="tab">{{ 'sections' | translate }}</a>
                    </li>
                    <li *ngIf="(permissions.ADD_SUBJECT == 'ENABLED' || permissions.VIEW_SUBJECTS == 'ENABLED')"><a
                        data-target="#subjects-tab" data-toggle="tab">{{ 'subjects' | translate }}</a></li>
                    <li *ngIf="(permissions.ADD_CLASSES == 'ENABLED' || permissions.VIEW_CLASS_SECTIONS == 'ENABLED')">
                      <a data-target="#staffs-tab" data-toggle="tab" (click)="openClassTeacherAssign()">{{ 'classTeacher' | translate }}</a>
                    </li>
                  </ul>
                </div><!--end .card-head -->
                <div class="card-body tab-content">
                  <!-- Students -->
                  <div class="tab-pane active" id="students-tab">
                    <form class="form-inline text-center search-groups" autocomplete="off"
                      style="margin-top: -1em;margin-bottom: 2em;">
                      <div class="form-group">
                        <h4 style="color: #6b6b6b;font-weight: 300;"> {{ 'sortStudentsBy' | translate }} </h4>
                      </div>
                      <div class="form-group">
                        <select class="form-control" id="selectedsection"
                          (change)="selectcategoryViewClassSection($event)">
                          <option value="0">{{ 'selectSection' | translate }}</option>
                          <option *ngFor="let section of getClassViewClassSectionArray"
                            value="{{section.claaSectionId}}">
                            {{section.className}} - {{section.classSection}}</option>
                        </select>
                      </div>
                      <button type="button" id="viewstud" class="btn btn-raised ink-reaction btn-info"
                        (click)="ViewstudentListClassSection()">{{ 'viewStudents' | translate }}</button>
                    </form>
                    <div id="class-detail-student-detail-tab">
                      <div class="table-responsive" *ngIf="!studentListClassSectionStatus">
                        <table id="view-class-detail-student-table" class="table table-striped class-details-table">
                          <thead>
                            <tr>
                              <th>{{ 'studentname' | translate }}</th>
                              <th>{{ 'rollnumber' | translate }}</th>
                              <th>{{ 'parentname' | translate }}</th>
                              <th>{{ 'mobilenumber' | translate }}</th>
                              <th>{{ 'dateofbirth' | translate }}</th>
                              <th>{{ 'gender' | translate }}</th>
                              <th>{{ 'isappuser' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let student of getClassSectionStudentListArray">
                              <td style="padding-left: 10px;">{{student.studentName}}</td>
                              <td style="padding-left: 10px;">{{student.rollNumber}}</td>
                              <td style="padding-left: 10px;">{{student.parentName}}</td>
                              <td style="padding-left: 10px;">{{student.mobileNumber}}</td>
                              <td style="padding-left: 10px;">{{student.dateOfBirth | date: 'yMMMd'}}</td>
                              <td style="padding-left: 10px;">{{student.gender == 1 ? 'Male':'Female'}}</td>
                              <td style="padding-left: 10px;">{{student.isAppUser == 1 ? 'Active':'Inactive'}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div><!--end .table-responsive -->
                      <div *ngIf="studentListClassSectionStatus" id="studentList" class="row col-md-12 text-center">
                        <h3>{{ 'noStudentsAreAssignedToThisClass' | translate }}</h3>
                      </div>
                    </div>
                  </div>
                  <!--edit section-->
                  <div id="editSectionModal-opener" data-toggle="modal" data-target="#editSectionModal"></div>
                  <div class="modal fade" id="editSectionModal" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog" style="margin-top: 8em;">
                      <div class="modal-content">
                        <div class="col-md-6 text-center"
                          style="background-color: var(--brand-primary-color);color: white;padding: 4.44em 0em;">
                          <i class="fa fa-th-large fa-4x" aria-hidden="true"></i>
                          <h3>{{ 'editSectionName' | translate }}</h3>
                          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                        </div>
                        <div class="col-md-6" style="background-color: white">
                          <button
                            style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -1em;float: right;border: none;"
                            type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                            aria-hidden="true">&times;</button>
                          <form class="form" role="form" style="padding: 2em 1em;">
                            <div class="form-group">
                              <input type="text" class="form-control" id="editSectionClassName"
                                [(ngModel)]="getSectionNameInClass" [ngModelOptions]="{standalone: true}">
                              <label for="editSectionClassName" style="font-size: small;">{{ 'className' | translate }}</label>
                            </div>
                            <div class="form-group">
                              <select id="cat" name="class lead" class="form-control" style="font-size: smaller;"
                                [(ngModel)]="sectionDetail.categoryId"
                                (change)="selectcategoryAddSection($event.target.value)">
                                <option *ngFor="let category of schoolCategories" value="{{category.categoryId}}">
                                  {{category.categoryName}}</option>
                              </select>
                              <label for="cat" style="font-size: small;">{{ 'category' | translate }}</label>
                            </div>
                          </form>
                          <div class="col-md-12 text-center" style="padding: 10px 0px;margin-top: -25px;">
                            <button type="button" id="updateSec" class="btn btn-raised ink-reaction btn-info btn-md"
                              (click)="UpdateSectionInStdView(getSectionNameInClass)">{{ 'update' | translate }}</button>
                            <button id="closeupdatesection" type="button"
                              class="btn btn-raised ink-reaction btn-info btn-md" data-dismiss="modal">{{ 'cancel' | translate }}</button>
                          </div>
                        </div>
                      </div><!-- /.modal-content -->
                    </div><!-- /.modal-dialog -->
                  </div>
                  <!--edit section ends-->
                  <!--delete section modal-->
                  <div id="deletesectionmodal-opener" data-toggle="modal" data-target="#deletesectionmodal"></div>
                  <div id="deletesectionmodal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog" style="margin-top: 8em;">
                      <div class="modal-content">
                        <div class="modal-body">
                          <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times"
                              style="color:var(--secondary-btn-bg-color);"></i> {{ 'deleteSection' | translate }}</h3>
                          <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                            style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
                            type="button">×</button>
                          <p style="    font-size: 19px;
    margin-left: 6pc;
    padding: 29px 30px;">{{ 'areYouConfirmToDeleteTheSection' | translate }}</p>
                          <div style="padding:0px 205px;    margin-top: -12px;">
                            <button (click)="deleteSectionInStdView()" class="btn btn-info btn-sm"
                              style="width: 67px;">{{ 'ok' | translate }}</button>
                            <button id="deletepopupclose" class="btn btn-info btn-sm"
                              data-dismiss="modal">{{ 'cancel' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end of delete section modal-->
                  <!-- Sections -->
                  <div class="tab-pane" id="sections-tab">
                    <div id="section-List" [style.display]="!enableSectionSequence ? '':'none'">
                      <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                        class="col-md-12 animated slideInUp" [class.hidden]="addNewSectionStatus"
                        style="text-align: center;">
                        <h4 style="color: #6b6b6b;font-weight: 300;display: inline-block;margin-right: 10px;"> {{ 'wantToAddMoreSectionInThisClass' | translate }} </h4>
                        <button type="button" class="btn btn-raised ink-reaction btn-info"
                          (click)="classViewAddNewSection()">{{ 'addNew' | translate }}</button>
                      </div>
                      <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                        class="col-md-12 text-center" style="color: #6b6b6b;font-weight: 300">
                        <h4>{{ 'wantToUpdateClassSectionOrder' | translate }} <span (click)="initiateSectionOrder()"
                            style="cursor: pointer"><u>{{ 'clickHere' | translate }}</u></span></h4>
                      </div>
                      <div class="col-md-12 animated slideInUp" [class.hidden]="!addNewSectionStatus"
                        style="text-align: center;margin-top: 15px;">
                        <form class="ng-untouched ng-pristine ng-valid" style="display: inline-block;">
                          <div class="form-group">
                            <input class="form-control" type="text" [(ngModel)]="getNewSectionName"
                              [ngModelOptions]="{standalone: true}">
                            <label for="class-name" style="font-size:small;margin-top: -1em;text-align: left;">{{ 'sectionName' | translate }}</label>
                          </div>
                        </form>
                        <button id="addSectionButton" type="button" class="btn btn-raised ink-reaction btn-info"
                          (click)="classViewAddNewSectionProcess()">{{ 'addSection' | translate }}</button>
                        <button type="button" class="btn btn-raised ink-reaction btn-info"
                          (click)="classViewAddNewSectionCancel()">{{ 'cancel' | translate }}</button>
                      </div>
                      <table class="table table-striped no-margin">
                        <thead>
                          <tr>
                            <th>{{ 'sectionName' | translate }}</th>
                            <th style="text-align: right;">{{ 'manageSection' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody class="add-section-table">
                          <tr *ngFor="let section of getClassViewClassSectionArray">
                            <td style="font-size: 18px;"><span
                                style="text-transform: uppercase;font-weight: 100;font-size: 13px;">{{ 'section' | translate }}</span><span
                                #sectionName
                                style="background: #9E9E9E;color: white;margin: 0px 5px;padding: 5px 25px;">{{section.classSection}}</span>
                            </td>
                            <td style="text-align: right;">
                              <a [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                                style="cursor:pointer;" class="btn btn-flat ink-reaction section-manage"
                                (click)="editSectionPopup();classViewSectionName(sectionName.innerText,sectionId.innerText,classStdId.innerText);getClassCategories();sectionDetails()"><i
                                  class="fa fa-edit"></i></a>
                              <a [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                                style="cursor:pointer;" class="btn btn-flat ink-reaction section-manage"
                                (click)="deleteSectionPopup();classViewSectionName(sectionName.innerText,sectionId.innerText,classStdId.innerText)"><i
                                  class="fa fa-trash"></i></a>
                              <span #sectionId style="display: none;">{{section.claaSectionId}}</span><span #classStdId
                                style="display: none">{{section.fkClassStandardsId}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 text-center" id="sectionOrder-Status"
                      style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 10em;">
                      <img src="images_ext/default.gif">
                      <h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>{{ 'pleaseWait' | translate }}</h3>
                    </div>
                    <div *ngIf="enableSectionSequence">
                      <div class="col-md-8 text-center">
                        <h3 style="color: var(--brand-primary-color);float: left;">{{ 'updateClassSectionOrder' | translate }}</h3>
                      </div>
                      <!-- <div class="col-md-4 text-right" style="padding-top: 15px;">
                        <button type="button" (click)="enableSectionSequence = false" class="btn btn-raised ink-reaction btn-info cancelSectionorder">Cancel</button>
                        <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="updateSectionOrder()">Save</button>
                      </div> -->
                      <table class="table table-striped class-details-table">
                        <thead>
                          <tr>
                            <th>{{ 'order' | translate }}</th>
                            <th>{{ 'sectionName' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody id="sequence-SectionList" class="add-section-table list">
                          <tr *ngFor="let section of getClassViewClassSectionArray; let i = index">
                            <td><input style="width: 30px; height: 30px;text-align: center;" type="text"
                                [(ngModel)]="section.SectionSequence" (keyup)="validateSectionOrder(section, i)" /></td>
                            <td style="font-size: 18px;">
                              <span
                                style="text-transform: uppercase;font-weight: 100;font-size: 13px;">{{ 'section' | translate }}</span><span
                                #sectionName
                                style="background: #9E9E9E;color: white;margin: 0px 5px;padding: 5px 25px;">{{section.classSection}}</span>
                              <span class="sectionId" #sectionId
                                style="display: none;">{{section.claaSectionId}}</span><span #classStdId
                                style="display: none">{{section.fkClassStandardsId}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col-md-12 text-right" style="padding: 10px 15px">
                        <button type="button" (click)="enableSectionSequence = false"
                          class="btn btn-raised ink-reaction btn-info cancelSectionorder">{{ 'cancel' | translate }}</button>
                        <button type="button" class="btn btn-raised ink-reaction btn-info"
                          (click)="updateSectionOrder()">{{ 'save' | translate }}</button>
                      </div>
                    </div>
                  </div>

                  <!-- Subjects -->
                  <div class="tab-pane" id="subjects-tab">
                    <div class="row col-md-12">
                      <div class="col-md-6">
                        <form class="form-inline text-center search-groups" autocomplete="off"
                          style="margin-top: -1em;margin-bottom: 2em;">
                          <div class="form-group">
                            <select id="selectSectionId" class="form-control">
                              <option value="0">{{ 'selectSection' | translate }}</option>
                              <option *ngFor="let section of getClassViewClassSectionArray"
                                value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}
                              </option>
                            </select>
                          </div>
                          <button type="button" id="viewSub" class="btn btn-raised ink-reaction btn-info"
                            (click)="viewSubject()">{{ 'viewSubject' | translate }}</button>
                        </form>
                      </div>
                      <div [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'"
                        class="col-md-6 text-center" style="margin-top: 1em;">
                        <div id="addSubject">
                          <h4 style="color: #6b6b6b;font-weight: 300;display: inline-block;margin-right: 10px;"> {{ 'wantToAddMoreSubjectsToClass' | translate }} </h4>
                          <button type="button" (click)="addMoreSubjectsToClass()"
                            class="btn btn-raised ink-reaction btn-info">{{ 'add' | translate }}</button>
                          <div id="open-assign-subject-to-class-popup" data-toggle="modal"
                            data-target="#assign-subject-to-class-popup"></div>
                        </div>
                        <div id="addNewSubject" style="display: none">
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-content text-left">
                                <input type="text" class="form-control" id="groupbutton9"
                                  [(ngModel)]="addSub.subjectname" name="addSubject">
                                <label for="groupbutton9" style="margin-top: -10px;">{{ 'subjectName' | translate }}</label>
                              </div>
                              <div class="input-group-btn">
                                <button id="addSub" class="btn btn-raised ink-reaction btn-info" type="button"
                                  (click)="addNewSubject(addSub)">{{ 'addSubject' | translate }}</button>
                                <button id="canceladdSubject" class="btn btn-raised ink-reaction btn-info" type="button"
                                  style="margin-left: 5px;">{{ 'cancel' | translate }}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 text-center" id="subject-Status" style="display: none;height: 100%">
                      <img src="images_ext/default.gif">
                      <h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>{{ 'pleaseWait' | translate }}</h3>
                    </div>
                    <table id="subject-table" class="table table-striped no-margin">
                      <thead>
                        <tr>
                          <th class="col-md-4">{{ 'subjectName' | translate }}</th>
                          <th class="col-md-5"><span>{{ 'allottedStaffs' | translate }}</span></th>
                          <th class="col-md-2">{{ 'assign/viewStudent' | translate }}</th>
                          <!--<th class="col-md-1">Total Student</th>-->
                          <th class="col-md-1">{{ 'remove' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody class="add-subject-table">
                        <tr *ngFor="let sub of subjectList;let i = index">
                          <td>{{sub.subject}}</td>
                          <td>
                            <form class="form" style="margin: -15px;">
                              <div class="form-group" style="margin: 0px;margin-top: -1em;">
                                <input [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'"
                                  [style.display]="sub.inClass ? '':'none'" type="text" id="searchStaff"
                                  name="search-staff" (change)="searchstaffForsubject(sub)" class="form-control"
                                  [(ngModel)]="sub.searchData" placeholder="Search staff to assign"
                                  data-role="tagsinput" style="font-size: small;font-weight: lighter;border: 0px;">
                              </div>
                              <div class="bootstrap-tagsinput" style="border: 0px;">
                                <span *ngFor="let staf of sub.staffList" class="tag label label-info"><span
                                    data-role="remove"
                                    (click)="unAssignStaffFromSubject(staf)">{{staf.staffName}}</span></span>
                              </div>
                              <div class="row col-md-9 card" id="search-staff_{{sub.subjectId}}"
                                *ngFor="let staff of sub.stafList" (click)="assignSubjectToStaff(staff,sub)"
                                style="margin: 0px;cursor: pointer">
                                <div class="col-md-4">
                                  <img src="{{staff.staffImage}}" class="img-circle" alt="staff" width="60" height="60"
                                    style="margin-top: 10px;">
                                </div>
                                <div class="col-md-8">
                                  <h4 class="staff-Name">{{staff.staffName}}</h4>
                                  <p class="designation" style="margin-top: -15px;">{{staff.designation}}</p>
                                  <p class="mob-number" style="margin-top: -20px;">{{staff.mobileNumber}}</p>
                                </div>
                              </div>
                            </form>
                          </td>
                          <td class="text-center"><a class="btn btn-flat ink-reaction"
                              (click)="getStudentListOfSubjectAssign(sub.subjectId)"
                              data-target="#assignSubjectToStudentPopup" data-toggle="modal">
                              <i class="md md-assignment"></i></a>
                          </td>
                          <!--<td>3</td>-->
                          <td class="text-center">
                            <a (click)="assignsubjectinclass(sub,false,i)"
                              *ngIf="!sub.isLoading && permissions.ADD_SUBJECT == 'ENABLED'"
                              class="btn btn-flat ink-reaction">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                            <i *ngIf="sub.isLoading" class="fa fa-spinner fa-spin"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Staffs -->
                  <div class="tab-pane" id="staffs-tab">
                    <div class="row col-md-12">
                      <div class="col-md-6">
                        <form class="form-inline text-center search-groups" autocomplete="off"
                          style="margin-top: -1em;margin-bottom: 2em;">
                          <div class="form-group">
                            <select id="selectSection" class="form-control">
                              <option value="0">{{ 'selectSection' | translate }}</option>
                              <option *ngFor="let section of getClassViewClassSectionArray"
                                value="{{section.claaSectionId}}">{{section.className}} - {{section.classSection}}
                              </option>
                            </select>
                          </div>
                          <button id="viewTeacher" type="button" class="btn btn-raised ink-reaction btn-info"
                            (click)="viewTeacher()">{{ 'viewClassTeacher' | translate }}</button>
                        </form>
                      </div>
                      <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'" class="col-md-6"
                        style="text-align: center;margin-top: 10px;">
                        <div id="addTeacher" style="display: none">
                          <h4 style="color: #6b6b6b;font-weight: 300;display: inline-block;margin-right: 10px;"> {{ 'wantToAddMoreClassTeacherInThisClass' | translate }} </h4>
                          <button type="button" (click)="editClassTeacher = null"
                            class="btn btn-raised ink-reaction btn-info" data-toggle="modal"
                            data-target="#add-class-teacher-popup" id="addnewteacher">{{ 'addNew' | translate }}</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 text-center" id="classTeacher-Status"
                      style="display: none;height: 100%;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding-top: 5em;">
                      <img src="images_ext/default.gif">
                    </div>
                    <div>
                      <div id="classTeacherList" class="col-md-12">
                        <div class="row col-md-12 card" *ngFor="let teacher of teacherList" style="padding: 20px 0; margin-bottom: 15px;">
                          <div class="col-md-1">
                            <img src="{{teacher.staffImage}}" class="img-circle" alt="staff" width="60" height="60"
                              style="margin-top: 13px">
                          </div>
                          <div class="col-md-2">
                            <h4 class="staff-Name">{{teacher.staffName}}</h4>
                            <p class="designation" style="margin-top: -10px;">{{teacher.designation}}</p>
                            <p class="mob-number" style="margin-top: -15px;">{{teacher.mobileNumber}}</p>
                          </div>
                          <div class="col-md-3">
                            <h3 style="color: dodgerblue">{{teacher.isAppUser == 0 ? 'Inactive' : 'Active'}} {{ 'inBluewingsApp' | translate:{ brandName: brand.name } }}</h3>
                          </div>
                          <div class = "col-md-4" >
                            <h3><label style="font-weight: normal;font-size: 16px;color: #606060;margin-right: 10px;">
                                {{'feeAccessInClassTeacherView' | translate}}</label></h3>

                                <div style="display: inline-block;">
                                     <button 
                                      type="button"
                                      (click)= "updateStaffPermissionForFeeAccess(teacher.staffId, true); teacher.isStaffHasPermissionToViewStudentFees = true; $event.stopPropagation();"
                                      [style.background]="teacher.isStaffHasPermissionToViewStudentFees ? 'var(--brand-primary-color)' : '#d3d3d3'"
                                      [style.color]="teacher.isStaffHasPermissionToViewStudentFees ? 'white' : '#606060'"
                                      style="border: none;padding: 6px 15px;border-radius: 3px 0 0 3px;cursor: pointer;outline: none;font-size: 12px;">
                                      <i class="fa fa-check"></i> {{'enable' | translate}}
                                   </button>
                                
                                      <button type="button" (click)="updateStaffPermissionForFeeAccess(teacher.staffId, false);teacher.isStaffHasPermissionToViewStudentFees = false; $event.stopPropagation();"
                                        [style.background]="!teacher.isStaffHasPermissionToViewStudentFees ? 'var(--brand-primary-color)' : '#d3d3d3'"
                                        [style.color]="!teacher.isStaffHasPermissionToViewStudentFees ? 'white' : '#606060'"
                                        style="border: none;padding: 6px 15px;border-radius: 0 3px 3px 0;cursor: pointer;outline: none;font-size: 12px;">
                                        <i class="fa fa-times"></i> {{'disable' | translate}}
                                      </button>
                                </div>



                          </div>
                          <div [style.display]="permissions.ADD_CLASSES == 'ENABLED' ? '':'none'"
                            class="col-md-2 text-right" style="margin-top: 20px;">
                            <a class="btn btn-flat ink-reaction" data-toggle="modal"
                              data-target="#add-class-teacher-popup" (click)="editclassTeacherPopUp(teacher)">
                              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </a>
                            <a class="btn btn-flat ink-reaction" data-toggle="modal" data-target="#remove-teacher"
                              (click)="removeclassTeacherPopUp(teacher.staffId,teacher.position)"
                              *ngIf="(teacher.position+1) == teacherList.length">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div id="noClassTeacher" class="col-md-12 text-center" style="display: none">
                        <h4>{{ 'thereAreNoClassTeachersAssignedForThisClass' | translate }}</h4>
                      </div>
                      <!--<div id="addNewClassTeacher"  class="row col-md-12 text-center card" style="height: 6em;display: none">
                        <div class="col-md-10 col-md-offset-2">
                          <input type="text" class="form-control" id="search-staff-assign" [(ngModel)]="teacher.searchTeacher"  name="searchTeacher" placeholder="Search staff for assign in this class" style="width: 80%;margin-top: 15px;">
                        </div>
                      </div>
                      <div id="stdTeacherList">
                        <div class="row col-md-12 card" *ngFor="let stafs of staffsList" id="search-teacher_{{stafs.staffId}}" (click)="assignClassTeacher(stafs)" style="margin: 0px;cursor: pointer">
                          <div class="col-md-4">
                            <img src="{{stafs.staffImage}}" class="img-circle" alt="staff" width="60" height="60" style="margin-top: 10px;">
                          </div>
                          <div class="col-md-8">
                            <h4 class="staff-Name">{{stafs.staffName}}</h4>
                            <p class="designation" style="margin-top: -15px;">{{stafs.designation}}</p>
                            <p class="mob-number" style="margin-top: -20px;">{{stafs.mobileNumber}}</p>
                          </div>
                        </div>
                      </div>-->
                    </div><!--end .card -->
                  </div>

                  <!-- time table -->
                  <div class="tab-pane" id="timetable-tab">
                    <form class="form-inline text-center search-groups" autocomplete="off">
                      <div class="form-group">
                        <label for="select13" class="control-label">{{ 'selectSection' | translate }}</label>
                        <select id="select13" name="select13" class="form-control">
                          <option value="">{{ 'selectOption' | translate }}</option>
                          <option value="section A">{{ 'sectionA' | translate }}</option>
                          <option value="section B">{{ 'sectionB' | translate }}</option>
                          <option value="section C">{{ 'sectionC' | translate }}</option>
                          <option value="section D">{{ 'sectionD' | translate }}</option>
                        </select>
                        <div class="form-control-line"></div>
                      </div>

                      <!-- <button type="submit" class="btn btn-raised btn-default-light ink-reaction">View Students</button> -->
                      <button type="button" class="btn btn-raised ink-reaction btn-info">{{ 'viewTimetable' | translate }}</button>
                      <!-- <button type="button" class="btn btn-raised ink-reaction btn-default-bright">Add Timetable</button> -->
                      <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="modal"
                        data-target="#add-new-timetable">{{ 'addTimetable' | translate }}</button>

                    </form>


                  </div>
                </div><!--end .card-body -->
              </div>
            </div><!--end .card -->
          </div>

        </div>
      </div>
      <!-- End view class canvas -->
      <!-- View Subject details -->
      <div id="offcanvas-view-classsubjects" class="offcanvas-pane width-12"
        style="width:1000px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-bg row" style="background: var(--secondary-btn-bg-color);min-height: 260px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center" style="position: absolute;top: 1em;">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'subjectDetails' | translate }}</p>
                <img src="assets/img/staff-symbol.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'viewSelectedSubjectDetailsHere' | translate }}</p>
                <div class="row">
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'subjectName' | translate }}</span><br>{{getViewsubjectName}}
                  </p>
                  <p class="lead"
                    style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;">
                    <span
                      style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">{{ 'totalClasses' | translate }}</span><br>{{getViewsubjectBelonging}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'selectedSubjectBelongingClasses' | translate }}</h4>
              <div [style.display]="permissions.ADD_SUBJECT == 'ENABLED' ? '':'none'"
                style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button data-toggle="modal" data-target="#updateSubject" type="button"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;z-index: 999;"><i
                    class="fa fa-pencil-square-o"></i></button>
              </div>
            </div>
          </div>
          <div class="col-md-12" style="padding: 3em 1em;">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body no-padding">
                  <ul class="list divider-full-bleed">
                    <li class="tile" *ngFor="let subjectclassview of getSubjectListViewArray">
                      <a class="tile-content ink-reaction">
                        <div class="tile-icon">
                          <h2 style="margin: 0"><i class="fa fa-leanpub"></i></h2>
                        </div>
                        <div class="tile-text">{{subjectclassview.className}}</div>
                        <p style="text-align: right;margin-top: -35px;"><span
                            style="background: var(--secondary-btn-bg-color);color: white;padding: 2px 10px;border-radius: 10px;">{{ 'section' | translate }}
                            {{subjectclassview.classSection}}</span></p>
                      </a>
                    </li>
                  </ul>
                </div><!--end .card-body -->
              </div><!--end .card -->
              <div class="col-md-12 text-center" id="unavailSub" style="display: none;padding: 2em 0em;">
                <h3>{{ 'thereAreNoAnyClassesExistInThisSubject' | translate }}</h3>
              </div>
              <em class="text-caption">{{ 'classesBelongingTheSelectedSubject' | translate }}</em>
            </div>
          </div>
        </div>
      </div>
      <!-- End view categories -->
    </div>
    <!-- End of Off Canvas -->
  </div><!--end #base-->
  <!-- END BASE -->
  <!--Remove Class Teacher-->
  <div class="modal fade" id="remove-teacher" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="padding: 10em 0em;">
      <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
        <div class="row text-center">
          <h4>{{ 'areYouConfirmToRemoveClassTeacherFromThisClass' | translate }}</h4>
        </div>
        <div class="text-center" style="padding: 8px 0px;">
          <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;"
            (click)="removeTeacherFromClass()">{{ 'delete' | translate }}</button>
          <button type="button" id="closeremoveTeacherpopup" class="btn btn-raised ink-reaction btn-info"
            style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
  <!--Remove Class Teacher-->
  <!--start deleteuser-->
  <div id="action-message" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content" style="margin-top: 190px">
        <div class="modal-body">
          <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-clock-o" style="color:var(--secondary-btn-bg-color);"></i>
            {{ 'changeTimeTableConfiguration' | translate }}</h3>
          <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
            style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
            type="button">×</button>
          <p id="action-message-info" style="padding: 10px 10px;"></p>
          <div style="padding:0px 205px;    margin-top: -12px;">
            <button (click)="changeTimeTableConfig()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'ok' | translate }}</button>
            <button id="closeTimeTableConfig" class="btn btn-info btn-sm" (click)="configButtonShow()"
              data-dismiss="modal">{{ 'cancel' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end delete user-->

  <!--start add subjects to the class-->
  <div id="assign-subject-to-class-popup" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content" style="margin-top: 190px">
        <div class="modal-body">
          <h3 style="margin: 0;font-weight: 100;color: #909090;">{{ 'addSubjectsToTheClass' | translate }}</h3>
          <br>
          <div *ngIf="isProcessing" style="text-align: center"><i class="fa fa-spinner fa-spin"></i></div>
          <div style="text-align: center" *ngIf="subjectListNotInClass.length == 0 && !isProcessing">{{ 'noMoreSubjectsToAdd' | translate }}</div>
          <div style="width: 95%;margin-left: 2%;" class="row">
            <div class="col-md-12" style="padding: 5px 10px;">
              <form class="form" style="overflow: auto;">
                <div class="checkbox checkbox-styled col-md-3" style="display: inline-block;margin: 0px;"
                  *ngFor="let s of subjectListNotInClass; let i = index">
                  <label>
                    <input type="checkbox" (change)="assignsubjectinclass(s,true,i)" [disabled]="s.inClass"
                      [(ngModel)]="s.inClass" name="{{'sub_'+s.subjectId}}">
                    <span title="{{s.subject}}">{{truncateText(s.subject,9)}}</span>
                  </label>
                </div>
              </form>
            </div>
          </div>
          <div style="text-align: center;">
            <button (click)="subjectListNotInClass.length > 0 ? viewSubject() : ''" data-dismiss="modal"
              class="btn btn-info btn-sm" style="width: 67px;">{{ 'done' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end add subjects to the class-->

  <!--start add subjects to the class-->
  <div id="add-class-teacher-popup" class="modal fade" role="dialog">
    <div class="modal-dialog" style="margin-top: -10%;">
      <div class="modal-content" style="margin-top: 190px">
        <button aria-hidden="true" id="close-assign-class-teacher-popup" class="close" data-dismiss="modal"
          style="margin: -15px;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;"
          type="button">×</button>
        <div class="modal-body">
          <h3 style="margin: 0;font-weight: 100;color: #909090;">{{ 'assignClassTeacherToTheClass' | translate }}</h3>
          <br>

          <!--<div style="text-align: center" *ngIf="subjectListNotInClass.length == 0 && !isProcessing">No more staff to add..!</div>-->
          <div style="width: 95%;margin-left: 2%;text-align: -webkit-center;" class="row">
            <input type="text" class="form-control" id="search-staff-assign" name="searchTeacher"
              placeholder="Search Class Teachers/ Co-ordinate's" (input)="selectedStaff = null" style="width: 80%;margin-top: 15px;">
            <br>
            <div *ngIf="isProcessing" style="text-align: center"><i class="fa fa-spinner fa-spin"></i></div>
            <div *ngIf="!isProcessing && staffsList.length > 0" [className]="staffsList.length == 0 ? 'hide' :''"
              style="height: 200px;overflow: auto;text-align: start;    width: 80%;">
              <!--<div style="text-align: center;margin-top: 20%;" *ngIf="staffsList.length == 0">No results found for your search</div>-->
              <div class="row col-md-12 card" *ngFor="let stafs of staffsList" id="search-teacher_{{stafs.staffId}}"
                (click)="selectStaff(stafs)" [style.background]="selectedStaff?.staffId === stafs.staffId ? 'var(--brand-primary-color)' : 'gainsboro'" style="margin: 0px;cursor: pointer;background: gainsboro;">
                <div class="col-md-4">
                  <img src="{{stafs.staffImage}}" class="img-circle" alt="staff" width="60" height="60"
                    style="margin-top: 10px;">
                </div>
                <div class="col-md-8">
                  <h4 class="staff-Name">{{stafs.staffName}}</h4>
                  <p class="designation" style="margin-top: -15px;">{{stafs.designation}}</p>
                  <p class="mob-number" style="margin-top: -20px;">{{stafs.mobileNumber}}</p>
                </div>
              </div>
            </div>

              <div *ngIf="selectedStaff" style="margin-top: 20px; width: 80%;">
      <div style="margin-bottom: 20px;">
        <label style="font-weight: normal;font-size: 16px;color: #606060;margin-right: 10px;">
         {{'feesAccessToStaff' | translate}}
        </label>
        
        <!-- Toggle Button -->
        <div style="display: inline-block;">
          <button 
            type="button"
            (click)="isStaffHasPermissionToViewStudentFees = true; $event.stopPropagation();"
            [style.background]="isStaffHasPermissionToViewStudentFees ? 'var(--brand-primary-color)' : '#d3d3d3'"
            [style.color]="isStaffHasPermissionToViewStudentFees ? 'white' : '#606060'"
            style="border: none;padding: 8px 20px;border-radius: 3px 0 0 3px;cursor: pointer;outline: none;">
            <i class="fa fa-check"></i> {{'enable' | translate}}
          </button>
          <button 
            type="button"
            (click)="isStaffHasPermissionToViewStudentFees = false; $event.stopPropagation();"
            [style.background]="!isStaffHasPermissionToViewStudentFees ? 'var(--brand-primary-color)' : '#d3d3d3'"
            [style.color]="!isStaffHasPermissionToViewStudentFees ? 'white' : '#606060'"
            style="border: none;padding: 8px 20px;border-radius: 0 3px 3px 0;cursor: pointer;outline: none;">
            <i class="fa fa-times"></i> {{'disable' | translate}}
          </button>
        </div>
      </div>

                 <div style="text-align: center;">
                  <button 
                    type="button"
                   (click)="assignClassTeacher(selectedStaff, isStaffHasPermissionToViewStudentFees)"
                    style="background: var(--brand-primary-color);color: white;border: none;padding: 10px 30px;border-radius: 3px;cursor: pointer;">
                    {{'addBtnText' | translate}}
                  </button>
                </div>
          <!--<div style="text-align: center;">
            <br>
            <button data-dismiss="modal" class="btn btn-info btn-sm" style="width: 67px;">CLOSE</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
  <!--end add subjects to the class-->

  <!--ASSIGN SUBJECT TO STUDENT MODEL START-->
  <div class="modal fade" id="assignSubjectToStudentPopup" tabindex="-1" role="dialog"
    aria-labelledby="simpleModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width: 85%;">
      <div class="modal-content">
        <div class="modal-header" style="padding: 0px 25px;">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
          <div class="row">
            <div class="col-md-12" style="text-align:center;margin-top: -1em;">
              <h3 class="text-primary"
                style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                  style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><img
                    src="images_ext/study.png"></span>{{ 'assignSubject' | translate }}</h3>
              <p style="margin: 0;color: #989898;margin-top: -5px;margin-bottom: 10px;margin-left: 5em;">{{ 'assignSubjectToStudentHere' | translate }} </p>
            </div>
          </div>
        </div>
        <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
          <div class="row">
            <div class="col-md-12" style="padding: 1em 2em;">
              <div id="studentListForAssignSubject">
                <div *ngIf="studentAssignStatus"
                  style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                  <div class="col-md-12" style="text-align: center;">
                    <img src="assets/img/search_icon_animation.gif" style="width: 300px;">
                    <h3 style="margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                  </div>
                </div>
                <div *ngIf="studentAssignNoData" class="col-md-12 text-center" style="color: teal;padding-top: 5em;">
                  <h3>{{ 'thereAreNoAnyStudentInThisClass' | translate }}</h3>
                </div>
                <div *ngIf="studentAssignData" class="table-responsive">
                  <table id="assignSubjectStudentTable" class="table table-striped class-details-table">
                    <thead>
                      <tr>
                        <th class="text-center">
                          <label class="checkbox checkbox-styled" style="height: 10px;">
                            <input type="checkbox" [(ngModel)]="selectAllForAssignStudent"
                              (change)="applyAllForAssignStudent()" name="applyToAllStudent">
                            <span>{{ 'selectAll' | translate }}</span>
                          </label>
                        </th>
                        <th>{{ 'studentname' | translate }}</th>
                        <th>{{ 'rollnumber' | translate }}</th>
                        <th>{{ 'parentname' | translate }}</th>
                        <th>{{ 'mobilenumber' | translate }}</th>
                        <th>{{ 'dateofbirth' | translate }}</th>
                        <th>{{ 'gender' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let student of studentListForSubject">
                        <td class="text-center">
                          <label class="checkbox checkbox-styled" style="height: 10px;">
                            <input type="checkbox" [(ngModel)]="student.studentSubjectStatus"
                              (change)="checkAllSelected()" name="{{'applyToStudent'+student.studentId}}">
                            <span>&nbsp;</span>
                          </label>
                        </td>
                        <td style="padding-left: 10px;">{{student.studentName}}</td>
                        <td style="padding-left: 10px;">{{student.rollNumber}}</td>
                        <td style="padding-left: 10px;">{{student.parentName}}</td>
                        <td style="padding-left: 10px;">{{student.mobileNumber}}</td>
                        <td style="padding-left: 10px;">{{student.dateOfBirth | date: 'yMMMd'}}</td>
                        <td style="padding-left: 10px;">{{student.gender == 1 ? 'Male':'Female'}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-md-12 text-center" style="padding: 10px 15px;">
                    <button type="button" id="assignSubjectToStudentButton" (click)="assignSubjectToStudent()"
                      class="btn btn-raised ink-reaction btn-info">{{ 'save' | translate }} </button>
                  </div>
                </div><!--end .table-responsive -->
              </div>
            </div>
          </div>
        </div>
        <!--<div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
          <div class="col-md-6">
            <p style="color: #717171;"><span style="color: red;">*</span> Internal Exam: Marks will not be included in report card</p>
          </div>
          &lt;!&ndash;<div class="col-md-4">
            <p style="color: #717171;">© 2017 {{ brand.name }}. All right reserved</p>
          </div>&ndash;&gt;
          <div class="col-md-6">
            <p style="color: #717171;"><span style="color: red">*</span> External Exam: Marks will be included in report card</p>
          </div>

        </div>-->
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <!--ASSIGN SUBJECT TO STUDENT MODEL END-->

  <!--End of Error collecting Fee-->

  <app-timetable-time-clash *ngIf="openTimetableTimeClashPopup" (save_button_event)="removeTimeSlot()"
    (closePopup)="cancelAction()" [visible]="openTimetableTimeClashPopup ? 'block' : 'none'"
    [fullMessageHTMLString]="fullMessageHTMLString" [showTimeSlot]="showTimeSlotClashed" [showClass]="showClassClashed"
    [staffImage]="staffImageClashed"></app-timetable-time-clash>

  <!--End Of Status-->
</div>








<!-- start modal for remove slot-->

<!--<div id="removetimeslotmodal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content" style="margin-top: 190px">
      <div class="modal-body">
        <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> Remove Time Slot</h3>
        <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
        <div class="col-md-3" style="width: 150px;min-height: 150px;margin: 0 auto;">
          <img src="{{staffImageToRemoveTimeSlot}}" id="staffimageforttimetble" style="margin-top: 43px;height: 80px;width: 80px;" class="img-responsive">
        </div>
        &lt;!&ndash;<div class="col-md-9">&ndash;&gt;
          <p id= "showmsg" style="font-size: 19px;margin-left: 6px;padding: 29px 30px;"></p>
        &lt;!&ndash;</div>&ndash;&gt;
        <p style="margin-top: -2em;font-size: 19px;margin-left: 99px;padding: 29px 30px;">Do you want to clear <span class="text-bold">{{showTimeslot}}</span> period in <span class="text-bold">{{showClass}}</span>?</p>
        <div style="padding:0px 205px;margin-top: -12px;">
          <button (click)="removeTimeSlot()" class="btn btn-info btn-sm" style="width: 67px;">YES</button>
          <button id="removetimeslot" class="btn btn-info btn-sm" data-dismiss="modal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- end modal for remove slot-->

<p-dialog [(visible)]="showGlobalAttendanceConfirmModal" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" [dismissableMask]="false" [style]="{ width: '450px' }"
  appendTo="body" class="global-attendance-confirm-dialog" (onHide)="closePopup()">
  <div class="global-attendance-confirm-body">
    {{'globalAttendanceSwitchMessage'| translate}}
  </div>
  <div class="global-attendance-confirm-footer">
    <button type="button" class="btn-cancel" (click)="closePopup()">{{'cancel' | translate}}</button>
    <button type="button" class="popup-request-btn" [disabled]="globalAttendanceLoader"
      (click)="handleGlobalAttendanceSwitch()">
      <ng-container *ngIf="globalAttendanceLoader; else notLoading">
        <app-button-loader></app-button-loader>
      </ng-container>
      <ng-template #notLoading>
        {{'switch' | translate}}
      </ng-template>
    </button>
  </div>
</p-dialog>